export default __webpack_public_path__ + "static/media/wrist_bg.a8fc8820.png";